<template>
  <div id="users" class="content" v-on:click="sectionClicked">
    <div class="contentTop">
      <div class="lthHeaderCnt">
        <div class="lBtn add" v-on:click="addEvent">New Event</div>
        <div class="searchCnt">
          <form v-on:submit.prevent="search">
            <input type="text" class="field" placeholder="Search event..."
              v-on:input="search" v-model="query">
            <button></button>
          </form>
          <div class="pageBtn refresh" v-on:click="getData"></div>
        </div>
        <div class="pagination">
          <div class="pageInfo" v-on:click="gotoPage">
            <template v-if="results.length > 0">
              {{((page * limit) + 1).toLocaleString('id')}}-{{((page
              * limit) + results.length).toLocaleString('id')}}
            </template><template v-else>0</template> dari
            {{total.toLocaleString('id')}}</div>
          <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
            v-on:click="prevPage"></div>
          <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
            * limit) + results.length) >= total}"
            v-on:click="nextPage"></div>
          <div class="pageBtn config" :class="{open: configOpen}"
            v-on:click.stop="configOpen = !configOpen; filterOpen = false;
            downloadOpen = false;">
            <div class="ddCnt" v-if="configOpen" v-on:click.stop="doNothing">
              <div class="ddItem">
                <h4>Item Per Page</h4>
                <div class="radioCnt">
                  <div class="radioItem" v-on:click="setItemPerPage(25)">
                    <div :class="{radio: 1, checked: limit === 25}"></div>
                    25 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(50)">
                    <div :class="{radio: 1, checked: limit === 50}"></div>
                    50 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(100)">
                    <div :class="{radio: 1, checked: limit === 100}"></div>
                    100 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(150)">
                    <div :class="{radio: 1, checked: limit === 150}"></div>
                    150 item per page
                  </div>
                  <div class="radioItem" v-on:click="setItemPerPage(250)">
                    <div :class="{radio: 1, checked: limit === 250}"></div>
                    250 item per page
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <perfect-scrollbar class="listingCntSc noTab">
      <div class="listingCnt">
        <div class="listingItemCnt">
          <table>
            <tr>
              <th class="th1">Event Name</th>
              <th>Created Date</th>
              <th colspan="2">Author</th>
            </tr>
            <tbody v-if="loading">
              <tr>
                <td colspan="5" class="tdLoading">
                  <SkAnimation :thumb="false" :tab="false" :header="false" type="user"/>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in results" :key="item.id">
                <td class="td1">
                  <div class="profile hasPhoto" v-if="item.media"
                    :style="{'background-image': `url('${item.media.imageTh}')`}"></div>
                  <div class="profile noImg" v-else></div>
                  {{item.name}}
                  <p v-if="item.descriptions">{{item.descriptions}}</p>
                </td>
                <td>
                  <template v-if="item.dateCreated">{{item.dateCreated | moment('D MMMM YYYY HH:mm')}}</template>
                  <template v-else>Unknown</template>
                </td>
                <td>
                  <template v-if="item.author">{{item.author.name}}</template>
                  <template v-else>Unknown</template>
                </td>
                <td class="tdAction">
                  <div class="actionWrapper">
                    <a :href="`${$config.frontEnd}id-id/invitation/${item.code}`" target="_blank" class="action btn">
                      <img src="../assets/link.png">
                      View Detail
                    </a>
                    <router-link :to="`/event/overview?id=${item.id}`" class="action stats" v-on:click.stop="openStats(item)"></router-link>
                    <div class="action" v-on:click.stop="itemOpenedId = item.id"></div>
                    <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                      v-on:click.stop="itemOpenedId = null"></div>
                    <div :class="{actionCnt: true, open: itemOpenedId == item.id}"
                      v-on:click.stop="doNothing">
                      <router-link :to="`/event/landing-page?id=${item.id}`"
                        class="actionItem" v-on:click.stop="editUser(index, item)">
                        <img src="../assets/landing-page.png"> Landing page
                      </router-link>
                      <router-link :to="`/event/overview?id=${item.id}`"
                        class="actionItem" v-on:click.stop="editUser(index, item)">
                        <img src="../assets/pie-chart.png"> Overview
                      </router-link>
                      <router-link :to="`/event/scaner?id=${item.id}`"
                        class="actionItem" v-on:click.stop="editUser(index, item)">
                        <img src="../assets/qr-scaner.png"> QR scaner attendance
                      </router-link>
                      <router-link :to="`/event/guest?id=${item.id}`"
                        class="actionItem" v-on:click.stop="editUser(index, item)">
                        <img src="../assets/user3-black.png"> Guest list
                      </router-link>
                      <div class="divider"></div>
                      <div class="actionItem" v-on:click.stop="deleteUser(index, item)">
                        <img src="../assets/private.png"> Unpublish
                      </div>
                      <div class="divider"></div>
                      <div class="actionItem actionRed" v-on:click.stop="deleteUser(index, item)">
                        <img src="../assets/delete.png"> Delete
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="tableInfo" v-if="!loading">
            Displaying {{limit.toLocaleString('id')}}
            of {{total.toLocaleString('id')}}
            items<br />&copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
            target="_blank">CMSRiver</a>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <FormInputerShort ref="formInputer"/>
    <UserImporter ref="userImporter"/>
    <Analytic ref="analytic"/>
    <UserDetail ref="userDetail"/>
    <AddEvent ref="addEvent"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import UserImporter from '@/components/UserImporter.vue';
import Analytic from '@/components/Analytic.vue';
import UserDetail from '@/components/UserDetail.vue';
import AddEvent from '@/components/AddEvent.vue';

export default {
  name: 'allEvent',
  components: {
    Confirmation,
    Snackbar,
    SkAnimation,
    FormInputerShort,
    UserImporter,
    Analytic,
    UserDetail,
    AddEvent,
  },
  data() {
    return {
      limit: 25,
      page: 0,
      total: 0,
      loading: true,
      results: [],
      itemOpenedId: null,
      role: '',
      roles: [],
      searchTimer: null,
      query: '',
      configOpen: false,
      downloadOpen: false,
      filterOpen: false,
    };
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    viewDetail(item) {
      this.$refs.userDetail.open(item);
    },
    doNothing() {},
    sectionClicked() {
      this.tabOpen = false;
      this.configOpen = false;
      this.filterOpen = false;
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getUsers();
      }, 500);
    },
    openStats(item) {
      this.$refs.analytic.open(item);
    },
    deleteUser(i, item) {
      this.itemOpenedId = null;
      const name = (item.name) ? item.name : 'User';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete ${name}?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted user,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete User',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.post(this.$config.uri('user/delete2'), {
          id: item.id,
        }).then((response) => {
          if (response.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: `${item.name} has been deleted.` });
        });
      });
    },
    undoDelete() {
      this.$http.post(this.$config.uri('user/restore'), { id: this.userWillDelete.id })
        .then((response) => {
          if (response.data.status !== 200) {
            // Display error
            return;
          }

          this.getUsers();
          this.snackbarAction = null;
          this.showSnackbar = `<b>${this.userWillDelete.name}</b> has been restored.`;
          setTimeout(() => {
            this.showSnackbar = null;
          }, 5000);
        });
    },
    addEvent() {
      this.$refs.addEvent.open(null, (b) => {
        if (b) this.getData();
      });
    },
    editUser(i, item) {
      this.itemOpenedId = null;
      this.$refs.userDialog.open({
        roles: this.roles,
        role: this.role,
        model: item,
      }, (b) => {
        if (b) this.getUsers();
      });
    },
    userOk() {
      this.itemOpenedId = null;
      this.showAddUser = false;
      this.getUsers();
    },
    gotoPage() {
      this.$refs.confirmDialog.open({
        title: 'Go To Page',
        desc: 'Input page number below',
        input: 'Page number...',
        action: 'Go To Page',
      }, (b, c, d) => {
        if (!b) return;
        const page = Number(d);
        if (Number.isNaN(page)) return;
        this.page = page - 1;
        const { slug } = this.$route.params;
        const dirId = this.$route.query.dirId || '';
        window.history.replaceState({}, `page-${this.page}`, `/users/admin?page=${this.page}`);
        this.getData();
      });
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      window.history.replaceState({}, `page-${this.page}`, `/users/admin?page=${this.page}`);
      this.getUsers();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      window.history.replaceState({}, `page-${this.page}`, `/users/admin?page=${this.page}`);
      this.getUsers();
    },
    setItemPerPage(itemPerPage) {
      this.configOpen = false;
      this.limit = itemPerPage;
      this.getUsers();
    },
    getData() {
      this.loading = true;
      const uri = `invitation?limit=${this.limit}&page=${this.page}&q=${this.query}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
      });
    },
  },
  mounted() {
    this.page = this.$route.query.page ? Number(this.$route.query.page) : 0;
    if (Number.isNaN(this.page)) this.page = 0;
    this.chTitle('All Events');
    this.chCGB(false);
    this.chDirId(0);
    this.getData();
  },
};
</script>


<style scoped lang="scss">
  .info{
    border-bottom: #eee 1px solid;
    margin: 0 -30px;
    .infoContent{
      padding: 20px 30px 30px;
      color: #444;
      max-width: 740px;
      font-size: 17px;
      h4{
        margin: 0 0 4px -3px;
        font-size: 40px;
      }
    }
  }
  .tabCnt{
    .tab{
      flex-grow: 1;
      width: auto;
      &.orange.active{
        &:after{
          background-color: orange;
        }
      }
      &.cyan.active{
        &:after{
          background-color: cyan;
        }
      }
      &.red.active{
        &:after{
          background-color: red;
        }
      }
      &.purple.active{
        &:after{
          background-color: purple;
        }
      }
      &:before{
        background-image: url(../assets/user-black.png);
      }
    }
  }

  .importBtn{
    border: #ccc 1px solid;
    margin-right: 16px;
    border-radius: 50px;
    padding: 5px 16px;
    padding-left: 40px;
    position: relative;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5f5;
      border-color: #bbb;
    }
    &:before{
      width: 20px;
      left: 14px; top: 0; bottom: 0;
      background-image: url(../assets/xls-file-green.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      display: block;
      content: "";
    }
  }

  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      cursor: pointer;

      position: relative;
      padding-left: 62px;
      float: none;
      margin-right: 0;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem.rejectAll{
      opacity: 1;
      color: red;
    }
    .lhItem:before{
      content: "";
      position: absolute;
      left: 12px; top: -1px;
      width: 36px; height: 36px;
      background-color: #ccc;
      border-radius: 50%;
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
      }
      th.th1{
        padding-left: 90px;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        vertical-align: top;
        &.tdLoading{
          padding: 0 30px;
          // border: none;
          &:hover{
            background-color: #fff;
          }
        }
        &.tdAction{
          vertical-align: top;
        }
        &.td1{
          padding-left: 90px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          p{
            margin: 2px 0 0;
            font-weight: normal;
            color: #767676;
            display: flex;
            .verified{
              display: block;
              width: 24px; height: 24px;
              margin-left: 4px;
              background-image: url(../assets/verified.png);
              background-size: 100% auto;
              background-position: center;
              background-repeat: no-repeat;
              margin-top: -2px;
              margin-bottom: -20px;
            }
          }
        }
        .profile{
          left: 30px; top: 50%;
          margin-top: -22px;
          position: absolute;
          width: 44px;
          height: 44px;
          // background-image: url(../assets/user.png);
          background-color: #eee;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 5px;
          opacity: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          text-transform: uppercase;
          line-height: 1;
          &.noImg{
            background-color: #ec174c;
            background-image: url(../assets/calendar-blank-bold-white.png);
            background-size: 20px auto;
          }
        }

        .actionWrapper{
          position: relative;
          display: flex;
          padding-right: 10px;
          justify-content: flex-end;
          align-items: center;
          .ttCnt{
            position: relative;
            .tt{
              position: absolute;
              top: 100%; right: -20px;
              background-color: rgba(0,0,0,.8);
              color: #fff;
              padding: 4px 10px;
              border-radius: 3px;
              display: none;
              font-size: 13px;
            }
            &:hover{
              .tt{
                display: block;
              }
            }
          }
        }
        .deliveryStats{
          display: flex;
          font-size: 13px;
          align-items: center;
          color: #767676;
          .statsItem{
            padding: 5px 10px;
            padding-left: 32px;
            position: relative;
            border-radius: 50px;
            cursor: pointer;
            &:before{
              content: "";
              position: absolute;
              left: 10px; top: 0; bottom: 0;
              width: 16px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              opacity: .5;
            }
            &:hover{
              background-color: #d7d7ea;
              color: #444;
              &:before{
                opacity: .6;
              }
            }
            &.waStats{
              &:before{
                background-image: url(../assets/whatsapp-o.png);
              }
            }
            &.smsStats{
              &:before{
                background-image: url(../assets/sms-o.png);
              }
            }
          }
        }
        .action{
          position: relative;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
          &.btn{
            width: auto;
            padding: 0 14px;
            margin-right: 6px;
            background: none;
            font-weight: 500;
            font-size: 14px;
            display: flex;
            align-items: center;
            border-radius: 50px;
            opacity: .8;
            border: #ccc 1px solid;
            height: 30px;
            &:hover{
              opacity: 1;
            }
            img{
              height: 16px;
              margin-right: 8px;
            }
          }
          &.star{
            background-image: url(../assets/star.png);
            &.stared{
              opacity: 1;
              background-image: url(../assets/star-active.png);
            }
          }
          &.share{
            background-image: url(../assets/share.png);
          }
          &.stats{
            background-image: url(../assets/pie-chart.png);
          }
          &:hover{
            background-color: #d7d7ea;
            opacity: .7;
          }
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 100%;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            display: block;
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 6px -2px -22px;
              opacity: .46;
            }
          }
          .actionItem.actionRed{
            color: red;
            img{
              opacity: 1;
            }
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
        // .action{
        //   position: absolute;
        //   right: 14px;
        //   top: 6px;
        //   width: 34px;
        //   height: 34px;
        //   border-radius: 50%;
        //   background-image: url(../assets/more.png);
        //   background-size: 18px auto;
        //   background-repeat: no-repeat;
        //   background-position: center;
        //   opacity: .4;
        //   cursor: pointer;
        // }
        // .action:hover{
        //   background-color: #ddd;
        //   opacity: .7;
        // }
        // .actionCnt{
        //   position: absolute;
        //   background: #fff;
        //   top: 40px;
        //   // border: 1px solid #ccc;
        //   box-shadow: 1px 1px 4px rgba(0,0,0,.2);
        //   border-radius: 10px;
        //   padding: 10px 0;
        //   white-space: nowrap;
        //   text-align: left;
        //   right: 14px;
        //   z-index: 4;
        //   margin-top: -5px;
        //   display: none;
        //   .divider{
        //     border-top: #eee 1px solid;
        //     padding-top: 4px;
        //     margin-top: 4px;
        //   }
        //   .actionItem{
        //     cursor: pointer;
        //     list-style: none;
        //     padding: 7px 42px;
        //     color: #444;
        //     font-size: 14px;
        //     min-width: 100px;
        //     img{
        //       height: 15px;
        //       margin: -4px 4px -2px -22px;
        //     }
        //   }
        //   .actionItem.actionRed{
        //     color: red;
        //   }
        //   .actionItem:hover{
        //     background-color: #eee;
        //   }
        // }
        // .actionCnt.open{
        //   display: block;
        // }
        // .actionOverlay{
        //   position: fixed;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        //   z-index: 3;
        //   display: none;
        // }
        // .actionOverlay.open{
        //   display: block;
        // }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
